var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    "data-name": "Vrstva 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172.02 168.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2",
    "data-name": "Vrstva 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.95,120.05c-16.44,13.64-39.76,13.56-56.37,1.5-15.22-11.05-21.93-29.29-17.26-47.55,4.89-19.12,22.35-32.52,41.16-33.61,20-1.15,38.89,10.02,45.94,29.35,6.43,17.64,1.47,37.92-13.47,50.31ZM116.45,60.93c-11.54-13.95-30.34-18.19-46.46-11.41-15.23,6.41-24.52,21.06-23.9,37.06.61,15.76,10.54,29.66,25.98,35.21,16.71,6,35.74.55,45.69-13.79,9.67-13.94,10.29-33.05-1.32-47.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,23.05c0,1.15-1.65,3.45-2.67,3.65-1.23.24-3.65-1.87-3.64-3.2l.09-20.39c0-1.16,1.64-2.98,2.62-3.1,1.35-.17,3.5,1.67,3.51,2.93l.1,20.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,165.08c0,1.15-1.67,3.42-2.7,3.6-1.24.21-3.57-1.91-3.57-3.27l.07-19.39c0-1.09,1.58-3.09,2.61-3.25,1.5-.24,3.52,1.69,3.53,3.19l.06,19.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,139.1c.68.68.74,3.7.23,4.43-.63.92-3.56,1.07-4.45.18l-14.75-14.58c-.74-.74-.54-3.08.25-3.77s4.09-.79,4.95.07l13.76,13.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.75,43.79c-.73.72-3.6.74-4.35.26-.93-.61-1.14-3.63-.3-4.43l14.66-14.19c.64-.61,3.42-.43,4.12.02.88.57,1.1,3.29.26,4.13l-14.39,14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.83,143.09c-1,.99-3.32,1.32-4.22.8s-1.57-3.88-.83-4.61l14.34-14.29c.96-.96,3.87-.77,4.51.11s.55,3.83-.33,4.7l-13.46,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.26,39.13c.73.71.73,3.65.28,4.36-.57.89-3.42,1.03-4.2.26l-14.15-13.95c-.68-.68-.73-3.09-.48-3.97s3.53-1.36,4.23-.68l14.33,13.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,86.74h-21.04c-1.06.01-3.23-1.98-3.21-3.03s2.13-2.76,3.21-2.76l19.82.07c1.19,0,2.98,1.2,3.47,1.9.6.88-1.11,3.82-2.24,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.86,86.76l-19.94-.13c-1.13,0-2.93-1.95-2.92-2.85s1.8-2.74,2.89-2.74h20.48c1.04.02,2.7,2.03,2.81,2.89.14,1.08-2.01,2.84-3.31,2.83Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasno);
export default __webpack_public_path__ + "static/media/jasno.bb0d8acc65b9e0cfe3311986c0b68bf7.svg";
export { ForwardRef as ReactComponent };